import { DirectionsBoat, Handshake } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { InvoiceFormField } from "./InvoiceFormField";

export const InvoiceAgreement = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Handshake style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Agreement")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <InvoiceFormField label={t("AgreementCode")} type="disabled" code="AgreementCode" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("AgreementName")} type="disabled" code="AgreementName" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("AgreementDays")} type="disabled" code="AgreementDays" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}